import React from 'react'
import PropTypes from 'prop-types'
import {Blocks} from '@builder.io/sdk-react'
import {defaultTitle} from './defaultConfig'
import {CustomAccordionTitle} from '@/components/accordion'

export const BuilderAccordionTitle = ({
    attributes,
    content = [],
    builderBlock,
    'data-testid': dataTestId
}) => {
    const {className, ...restAttributes} = attributes

    return (
        <CustomAccordionTitle
            className={className}
            {...restAttributes}
            data-testid={dataTestId || 'accordionTitle-AccordionTitle'}
            renderContent={() => (
                <Blocks
                    path="component.options.content"
                    blocks={content}
                    parent={builderBlock?.id}
                    data-testid="accordionTitle-Blocks"
                />
            )}
        />
    )
}
BuilderAccordionTitle.propTypes = {
    attributes: PropTypes.object,
    content: PropTypes.arrayOf(PropTypes.object.isRequired),
    builderBlock: PropTypes.object,
    'data-testid': PropTypes.string
}

export const AccordionTitleDefinition = {
    component: BuilderAccordionTitle,
    name: 'AccordionTitle',
    noWrap: true,
    canHaveChildren: true,
    shouldReceiveBuilderProps: {
        builderBlock: true
    },
    defaultStyles: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch'
    },
    inputs: [
        {
            name: 'content',
            type: 'uiBlocks',
            broadcast: true,
            defaultValue: defaultTitle
        }
    ]
}
